import React, { PureComponent } from "react";
import PnmacHtmlToNative from './Platform/HtmlToNative';
export default PnmacHtmlToNative;